import LogoImage from "@/components/LogoImage";

export default function PilotAvatar({ pilot, size = 44, className = "" }) {
  const avatarSvg = `/api/pilots/${pilot.id}/avatar.svg`;
  return (
    <LogoImage
      src={pilot.foto_url || avatarSvg}
      fallbackSrc={avatarSvg}
      alt={`${pilot.nome} ${pilot.cognome}`}
      loading="lazy"
      data-testid={`pilot-avatar-${pilot.id}`}
      style={{ width: size, height: size }}
      className={`rounded-lg object-cover border border-[#3F3F4C] bg-[#121214] shrink-0 ${className}`}
    />
  );
}
